import { FaGuitar } from "react-icons/fa";
import { FiCoffee } from "react-icons/fi";
import { BsFillMoonFill } from "react-icons/bs";
import { Icons } from "../components/Icons/Icons";
import { PlaylistType, soundType } from "../types/interface";

export const YOUTUBE_URL = `https://www.youtube.com/embed/`;
export const IMAGE_SRC = {
  LOGO: require("../assets/images/logo.gif"),
  loading: require("../assets/images/loading.gif"),
  bg: require("../assets/images/bgVideo.png"),
  playing: require("../assets/images/playing.gif"),
  logosmall: require("../assets/images/logosmall.png"),
  chillThumb: require("../assets/images/chillimg.png"),
  slowdownThumb: require("../assets/images/slowgardenimg.png"),
  artroomThumb: require("../assets/images/artroom.png"),
  seoulThumb: require("../assets/images/seoulimg.png"),
  greenhouseThumb: require("../assets/images/greenhouseimg.png"),
  honoluluThumb: require("../assets/images/honoluluimg.png"),
  vanThumb: require("../assets/images/vanimg.png"),
  summerThumb: require("../assets/images/summerimg.png"),
  dreamingThumb: require("../assets/images/dreamingimg.png"),
  futureThumb: require("../assets/images/future.png"),
  cafeThumb: require("../assets/images/cafeimg.png"),
  lakehouseThumb: require("../assets/images/lakehouseimg.png"),
  thewoodThumb: require("../assets/images/thewoodimg.png"),
  seaThumb: require("../assets/images/sea.png"),
  fujiThumb: require("../assets/images/fuji.png"),
  smile: require("../assets/images/smile.png"),
  momo: require("../assets/images/momo.png"),
  qr: require("../assets/images/qrcode.webp"),
  logomomo: require("../assets/images/logomomo.png"),
  borderqr: require("../assets/images/borderqr.svg"),
  scan: require("../assets/images/scan.png"),
  treeHouse: require("../assets/images/treehouse.png"),
};

export const VideoSource = {
  chillvibes: {
    chillDay: require("../assets/videos/chillday.mp4"),
    chillDayRain: require("../assets/videos/chilldayrain.mp4"),
    chillNight: require("../assets/videos/chillnight.mp4"),
    chillNightRain: require("../assets/videos/chillnightrain.mp4"),
  },
  treeHouse: {
    treeDay: require("../assets/videos/treeday.mp4"),
    treeDayRain: require("../assets/videos/treedayrain.mp4"),
    treeNight: require("../assets/videos/treenight.mp4"),
    treeNightRain: require("../assets/videos/treenightrain.mp4"),
  },
  slowGarden: {
    slowDay: require("../assets/videos/slowdownday.mp4"),
    slowNight: require("../assets/videos/slowdownnight.mp4"),
  },
  artRoom: {
    artroomDay: require("../assets/videos/artroomday.mp4"),
    artroomDayrain: require("../assets/videos/artroomdayrain.mp4"),
    artroomNight: require("../assets/videos/artroomnight.mp4"),
    artroomNightRain: require("../assets/videos/artnightrain.mp4"),
  },
  lakeHouse: {
    lakeHouseDay: require("../assets/videos/lakehouseday.mp4"),
    lakeHouseDayrain: require("../assets/videos/lakehousedayrain.mp4"),
    lakeHouseNight: require("../assets/videos/lakehousenight.mp4"),
    lakeHouseNightRain: require("../assets/videos/lakehousenightrain.mp4"),
  },

  sea: {
    seaDay: require("../assets/videos/seaday.mp4"),
    seaDayrain: require("../assets/videos/seadayrain.mp4"),
    seaNight: require("../assets/videos/seanight.mp4"),
    seaNightrain: require("../assets/videos/seanightrain.mp4"),
  },

  fuji: {
    fujiDay: require("../assets/videos/fujiday.mp4"),
    fujiNight: require("../assets/videos/fujinight.mp4"),
  },
  thewood: {
    thewoodDay: require("../assets/videos/thewoodday.mp4"),
    thewoodDayrain: require("../assets/videos/thewooddayrain.mp4"),
    thewoodNight: require("../assets/videos/thewoodnight.mp4"),
    thewoodNightRain: require("../assets/videos/thewoodnightrain.mp4"),
  },
  seoul: {
    seoulDay: require("../assets/videos/seoulday.mp4"),
    seoulDayRain: require("../assets/videos/seouldayrain.mp4"),
    seoulNight: require("../assets/videos/seoulnight.mp4"),
    seoulNightRain: require("../assets/videos/seoulnightrain.mp4"),
  },
  greenhouse: {
    greenhouseDay: require("../assets/videos/greenhouseday.mp4"),
    greenhouseDayRain: require("../assets/videos/greenhousedayrain.mp4"),
    greenhouseNight: require("../assets/videos/greenhousenight.mp4"),
    greenhouseNightRain: require("../assets/videos/greenhousenightrain.mp4"),
  },
  honolulu: {
    honoluluDay: require("../assets/videos/honoluluday.mp4"),
    honoluluRain: require("../assets/videos/HonoluluDayRain.mp4"),
    honoluluNight: require("../assets/videos/HonoluluNight.mp4"),
    honoluluNightRain: require("../assets/videos/HonoluluRainNight.mp4"),
  },

  van: {
    vanDay: require("../assets/videos/vanfire.mp4"),
    vanDayRain: require("../assets/videos/vanin.mp4"),
    vanNight: require("../assets/videos/vanout.mp4"),
    vanNightRain: require("../assets/videos/vanrain.mp4"),
  },
  summer: {
    summerDay: require("../assets/videos/summer.mp4"),
    summerDayRain: require("../assets/videos/summerdayrain.mp4"),
    summerNight: require("../assets/videos/summerout.mp4"),
    summerNightRain: require("../assets/videos/summeroutrain.mp4"),
  },
  dreaming: {
    dreamingNight: require("../assets/videos/dreaming.mp4"),
    dreamingWatter: require("../assets/videos/dreamingwater.mp4"),
  },
  future: {
    furure: require("../assets/videos/galaxy.mp4"),
    futureGalaxy: require("../assets/videos/bedroomcity.mp4"),
  },
  cafe: {
    dayCafe: require("../assets/videos/inDayCafe.mp4"),
    dayCafeRain: require("../assets/videos/inDayCafeRain.mp4"),
    nightCafe: require("../assets/videos/inCafeNight.mp4"),
    nightCafeRain: require("../assets/videos/inCafeNightRain.mp4"),
  },
};

export const soundSrc = {
  rainSound: require("../assets/sound/rainsound.mp3"),
};
export const playlist = {
  chill: {
    title: "Chill",

    songs: [
      {
        id: 1,
        name: "Chill",
        source: require("../assets/songs/chill1.mp3"),
      },
      {
        id: 2,
        name: "Chill",
        source: require("../assets/songs/chill2.mp3"),
      },
      {
        id: 3,
        name: "Chill",
        source: require("../assets/songs/chill3.mp3"),
      },
      {
        id: 4,
        name: "Chill",
        source: require("../assets/songs/chill4.mp3"),
      },
      {
        id: 5,
        name: "Chill",
        source: require("../assets/songs/chill5.mp3"),
      },
      {
        id: 6,
        name: "Chill",
        source: require("../assets/songs/chill6.mp3"),
      },
      {
        id: 7,
        name: "Chill",
        source: require("../assets/songs/chill7.mp3"),
      },
      {
        id: 8,
        name: "Chill",
        source: require("../assets/songs/chill8.mp3"),
      },
      {
        id: 9,
        name: "Chill",
        source: require("../assets/songs/chill9.mp3"),
      },
      {
        id: 10,
        name: "Chill",
        source: require("../assets/songs/chill10.mp3"),
      },
      {
        id: 11,
        name: "Chill",
        source: require("../assets/songs/chill11.mp3"),
      },
      {
        id: 12,
        name: "Chill",
        source: require("../assets/songs/chill12.mp3"),
      },
    ],
  },
  rap: {
    title: "Rap",

    songs: [
      {
        id: 1,
        name: "Cơn gió ngang",
        source: require("../assets/songs/congiongang.mp3"),
      },

      {
        id: 2,
        name: "Đôi ba chiếc lá (Khói)",
        source: require("../assets/songs/doibachiecla.mp3"),
      },
      {
        id: 3,
        name: "Hai đám mây (khói)",
        source: require("../assets/songs/haidammay.mp3"),
      },
    ],
  },
  sleep: {
    title: "Sleep",
    songs: [
      {
        id: 1,
        name: "Naruto - Shippuden",
        source: require("../assets/songs/sleep.mp3"),
      },
      {
        id: 2,
        name: "sleep",
        source: require("../assets/songs/sleep2.mp3"),
      },
    ],
  },
  spotify: {
    songs: [
      {
        id: 1,
        name: "Shape of you",
        artistName: "Ed Sheeran",
        thumbnail: require("../assets/images/shapeofyou.webp"),
        source: require("../assets/songs/shapeofyou.mp3"),
        duration: "04:23",
      },
      {
        id: 2,
        name: "Burn Out",
        artistName: "Martin Garrix & Justin Mylo",
        thumbnail: require("../assets/images/burnout.webp"),
        source: require("../assets/songs/burnout.mp3"),
        duration: "03:37",
      },
      {
        id: 3,
        name: "What Are Words",
        artistName: "Chris Medina",
        thumbnail: require("../assets/images/whatarewords.webp"),
        source: require("../assets/songs/whatarewords.mp3"),
        duration: "03:12",
      },
      {
        id: 4,
        name: "The hills",
        artistName: "The Weeknd",
        thumbnail: require("../assets/images/thehills.webp"),
        source: require("../assets/songs/thehills.mp3"),
        duration: "03:55",
      },
      {
        id: 5,
        name: "Dusk Till Dawn",
        artistName: "ZAYN, Sia",
        thumbnail: require("../assets/images/dusktilldawn.webp"),
        source: require("../assets/songs/dusktilldawn.mp3"),
        duration: "03:56",
      },
      {
        id: 6,
        name: "Counting Stars",
        artistName: "OneRepublic",
        thumbnail: require("../assets/images/countingstars.webp"),
        source: require("../assets/songs/countingstars.mp3"),
        duration: "04:18",
      },
      {
        id: 7,
        name: "Home",
        artistName: "Machine Gun Kelly",
        thumbnail: require("../assets/images/home.webp"),
        source: require("../assets/songs/home.mp3"),
        duration: "03:52",
      },
      {
        id: 8,
        name: "So Far Away",
        artistName: "Martin Garrix",
        thumbnail: require("../assets/images/sofaraway.webp"),
        source: require("../assets/songs/sofaraway.mp3"),
        duration: "03:03",
      },
    ],
  },
};

export const PlaylistSong: PlaylistType[] = [
  {
    playlistId: "chill",
    title: "Chill",
    icon: <FiCoffee />,
    songs: playlist.chill.songs,
  },
  {
    playlistId: "rap",
    title: "Rap",
    icon: <FaGuitar />,
    songs: playlist.rap.songs,
  },
  {
    title: "Sleep",
    playlistId: "sleep",
    icon: <BsFillMoonFill />,
    songs: playlist.sleep.songs,
  },
  {
    title: "Spotify",
    playlistId: "spotify",
    icon: <BsFillMoonFill />,

    songs: playlist.spotify.songs,
  },
];

export const soundEffect: soundType[] = [
  {
    id: 0,
    type: "City traffic",
    source: require("../assets/sound/citytraffic.mp3"),
    icon: Icons.cityTraffic,
    levelSound: 0,
  },
  {
    id: 1,
    type: "City Rain",
    source: require("../assets/sound/raincity.mp3"),
    icon: Icons.cityRain,
    levelSound: 0,
  },
  {
    id: 2,
    type: "Campfire",
    source: require("../assets/sound/firesound.mp3"),
    icon: Icons.cityRain,
    levelSound: 0,
  },
  {
    id: 3,
    type: "Forest",
    source: require("../assets/sound/forestnight.mp3"),
    icon: Icons.cityRain,
    levelSound: 0,
  },
  {
    id: 4,
    type: "Summer Storm",
    source: require("../assets/sound/summerstorm.mp3"),
    icon: Icons.cityRain,
    levelSound: 0,
  },
  {
    id: 5,
    type: "Forest Rain",
    source: require("../assets/sound/rainforest.mp3"),
    icon: Icons.cityRain,
    levelSound: 0,
  },
  {
    id: 6,
    type: "Bird Chirping",
    source: require("../assets/sound/birds.mp3"),
    icon: Icons.cityRain,
    levelSound: 0,
  },
  {
    id: 7,
    type: "Keyboard",
    source: require("../assets/sound/keyboard.mp3"),
    icon: Icons.cityRain,
    levelSound: 0,
  },
  {
    id: 8,
    type: "Wind",
    source: require("../assets/sound/wind.mp3"),
    icon: Icons.cityRain,
    levelSound: 0,
  },
  {
    id: 9,
    type: "Ocean",
    source: require("../assets/sound/ocean.mp3"),
    icon: Icons.cityRain,
    levelSound: 0,
  },
];
export const iconList: { id: string; children: string[] }[] = [
  {
    id: "smile",
    children: [
      "😀",
      "😄",
      "😅",
      "😁",
      "🤣",
      "😊",
      "😇",
      "🙂",
      "🙃",
      "😉",
      "😌",
      "😍",
      "🥰",
      "😘",
      "😗",
      "😚",
      "😋",
      "😛",
      "😝",
      "😜",
      "🤪",
      "🤨",
      "🤓",
      "😎",
      "🤩",
      "🥳",
      "😏",
      "😞",
      "😟",
      "😖",
      "😫",
      "😩",
      "😢",
      "😭",
      "😤",
      "😠",
      "😡",
      "🤬",
      "🤯",
      "😳",
      "🥵",
      "🥶",
      "😱",
      "😨",
      "😰",
      "😓",
      "🤔",
      "🤭",
      "🤫",
      "😐",
      "🙄",
      "😯",
      "😧",
      "😴",
      "🤤",
      "😪",
      "😮‍💨",
      "🤢",
      "🤮",
      "🤕",
      "😈",
      "👹",
      "💩",
      "👻",
      "❤️",
      "💙",
      "💝",
      "🙌",
      "🤝",
      "✊",
      "🤟",
    ],
  },
  {
    id: "animal",
    children: [
      "🐶",
      "🐱",
      "🐭",
      "🦊",
      "🐻",
      "🐼",
      "🐨",
      "🐯",
      "🦁",
      "🐮",
      "🐷",
      "🐸",
      "🐵",
      "🙈",
      "🐒",
      "🐔",
      "🐧",
      "🐦",
      "🐥",
      "🦅",
      "🦉",
      "🦇",
      "🐗",
      "🦄",
      "🐝",
      "🐛",
      "🦋",
      "🐞",
      "🐜",
      "🐢",
      "🦎",
      "🐙",
      "🦞",
      "🦀",
      "🐠",
      "🐟",
      "🐳",
      "🦈",
      "🐆",
      "🦍",
      "🦛",
      "🐪",
      "🦘",
      "🐏",
      "🐐",
      "🐕",
      "🦃",
      "🦚",
      "🦜",
    ],
  },
];
